import React, { Component } from "react";
import { MenuItems } from "./MenuItems";
import './Navbar.css';
import { Button } from "../Button";
import logo from "../Images/signature.png";

class Navbar extends Component {
    state = { clicked: false }

    handleClick = () => {
        this.setState({ clicked: !this.state.clicked })
    }

    render() {
        const handleLogoClick = () => {
            window.open("/","_self");
        };

        return (
            <nav className="NavbarItems">
                <div className="navbar-logo">
                    <img src={logo} onClick={handleLogoClick} alt="logo" />
                    {/* <span className="navbar-brand-name">Luke Hickman</span> */}
                </div>
                <div className="menu-icon" onClick={this.handleClick}>
                    <i className={this.state.clicked ? 'fa fa-times' : 'fa fa-bars'}/>
                </div>
                <ul className={this.state.clicked ? 'nav-menu active' : 'nav-menu'}>
                    {MenuItems.map((item, index) => {
                        return (
                            <li key={index}>
                                <a className={item.cName} href={item.url}>
                                    {item.title}
                                </a>
                            </li>
                        )
                    })}
                </ul>
            </nav>
        )
    }
}

export default Navbar;
